module.exports = __webpack_public_path__ + "fee66e712a8a08eef5805a46892932ad.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/fontawesome-webfont.woff
// module id = 1316
// module chunks = 28